$(document).ready(function(){

  // Product page redirects
  if (String(window.location.href).indexOf("/products/tikro-silko-pagalves-uzvalkalai") != -1 ){
    console.log('SHould be redirect');
    window.location = 'https://noreo.lt/products/noreo-naturalaus-silko-pagalves-uzvalkalas';
  }

  // Selecting by default first color, loading animations ant etc
  setTimeout(function(){
      $('.First_variant_trigger').trigger('click');
      $('.Product_section_image_gallery').addClass('loaded');
      $('.Product_images_mob').addClass('loaded');
  },100);

  // Setting up random active users
  const min = 30;
  const max = 130;
  const active_users = Math.floor(Math.random() * (max - min + 1) + min);
  $('.Atc_active_users_js').text(active_users);

  // Variant selection catching, image gallery switching by variant
  $('.product-form__input.Color_selector input').click(function(){
      var data = $(this).attr('value');
      $('.js.product-form__input.Color_selector').find('.form__label').text('Valige oma värv: '+data);
      var data_handle = data.toLowerCase().replace(/ /g,'-').replace('š', 's').replace('ė', 'e').replace('ž', 'z');
      $('.Product_main_image').hide();
      $('.Product_main_image').each(function(){
        var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
          if (current_color == data_handle ){
            console.log(current_color, data_handle);
              $(this).show();
          }
      });
    
    $('.product_main_images_slider').hide();
    $('.product_main_images_slider_nav').hide();
    $('.product_main_images_slider_nav').each(function(){
      var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
      if (current_color == data_handle ){
        $(this).show();
      }
    });
    $('.product_main_images_slider').each(function(){
      var current_color = $(this).attr('data').replace('-mobile', '').replace('-desktop1', '').replace('-desktop2', '').replace('-narrow', '');
      if (current_color == data_handle ){
        $(this).show();
      }
    });
    $('.product_main_images_slider').slick('refresh');
    $('.product_main_images_slider_nav').slick('refresh');
    // if ($(window).width() < 800) {
    // $('html, body').animate({
    //   scrollTop: $(".Product_images_mob").offset().top-50
    // }, 200);
    // }
  });

  // Product accordion functionality
  $('.Product_info_accordion_cell').click(function(){
      $(this).find('.inner').slideToggle();
      $(this).find('.accordion_img').toggle();
  });

  // Product carousel mobile gallery
  $('.product_main_images_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.product_main_images_slider_nav',
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowLeft.png?v=1681385120'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0741/8996/3571/files/arrowRight.png?v=1681385120'/></button>"
  });
  $('.product_main_images_slider_nav').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.product_main_images_slider',
    focusOnSelect: true
  });

  $('.product-variant-id').change(function(){
    var currentId = $(this).attr('value');
    var currentInventory = 0;
    $('.Product_form_variant_checker__js').each(function(){
      if ($(this).attr('data-id') == currentId){
        currentInventory = parseFloat($(this).attr('data-inv'));
      }
    });
    console.log(currentInventory, 'STOCK');
    if (currentInventory < 1){
      $('.Product_atc_button').text('Välja müüdud');
      $('.Product_atc_button').attr('data-stock', '0')
    }
    if (currentInventory > 0){
      $('.Product_atc_button').text('Lisa ostukorvi');
      $('.Product_atc_button').attr('data-stock', '1')
    }
  });

// Product section, size chart popup
  $('.Product_variant_size_chart').click(function(){
    $('.Product_popup_whole').css('display', 'flex');
  });

  $('.Product_popup_inner_close').click(function(){
    $('.Product_popup_whole').hide();
  });

// Features Switch
$('.Product_features_nav_bubble').click(function(){
  var data = $(this).attr('data');
  $('.Product_features_image__js').hide();
  $('.Product_features_image__js').each(function(){
    if ($(this).attr('data') == data){
      $(this).show();
    }
  });
});

// Faq
$('.Faq_accordion_cell').click(function(){
  $(this).toggleClass('active');
  $(this).find('.Faq_accordion_content').slideToggle();
});

// Scroll animation

$('.scroll_to_js').click(function(){
  $('html, body').animate({
    scrollTop: $(".Product_section_main").offset().top-100
}, 200);
});

// Carousel slick
$('.Product_page_gallery_carousel').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

  $('.Product_gallery_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '50px',
    arrows: false,
  });

// Hero banner cta functionality
  $('.Product_hero_cta_box').click(function(){
    $('html, body').animate({
      scrollTop: $(".Product_section_main").offset().top
  }, 200);
  });

  // Sticky header
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
        // Customer has scrolled below 400 pixels from the top
        // $('.Product_header_outer.Bottom').css('bottom', '0');
        // Add your desired code or actions here
    }
    else{
      // $('.Product_header_outer.Bottom').css('bottom', '-300px');
    }
  });

  
});